var map = {
	"./b.png": "ef7e",
	"./electrical_circuit.png": "1788",
	"./electron_beam.png": "a6b6",
	"./light.png": "8c3f",
	"./resonance_tube.png": "3518",
	"./spring_mass_system.png": "e3f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6aca";